<template>
    <div class="flex font-semibold" > {{selfMessage ? "Vous" : (message?.sender_name ?? message?.sender_phone)}}</div>
    <div class="flex my-2 " v-if="message?.type != 'chat'">
        <i class="text-sm font-bold mr-1 fas fa-music" v-if="message?.type == 'audio'"></i>
        <i class="text-sm font-bold mr-1 fas fa-image" v-else-if="message?.type == 'image'"></i>
        <i class="text-sm font-bold mr-1 fas fa-video" v-else-if="message?.type == 'video'"></i>
        <i class="text-sm font-bold mr-1 fas fa-microphone" v-else-if="message?.type == 'ptt'"></i>
        <i class="text-sm font-bold mr-1 fas fa-location-arrow" v-else-if="message?.type == 'location'"></i>
        <i class="text-sm font-bold mr-1 fas fa-circle-user" v-else-if="message?.type == 'vcard'"></i>
        <i class="text-sm font-bold mr-1 fas fa-file" v-else></i>
        <span class="line-clamp-1 text-ellipsis ">{{ message?.type == "ptt" ? 'Vocal'
            : toPascalCase(message?.type ?? '') + " " + (message?.filename ?? '') }} </span>
    </div>
    <p class="line-clamp-3 text-ellipsis my-3" :class="!message?.selfMessage && !message?.isRead ? 'font-bold' : ''"
        v-else>{{
            JSON.parse(message?.content ?? '') ?? "" }}</p>
</template>
<script>
import { toPascalCase } from '@/utils';

export default {
    name: "ReplyWidget",
    props: {
        message: {
            required: true,
            type: Object
        }
    },
    computed: {
        selfMessage() {
            return this.message?.message_id?.startsWith("true");
        },
    },
    methods: {
        toPascalCase,
    }
}
</script>